export default "__VITE_ASSET__BESQDgGv__"